import Menu from 'semantic-ui-react/dist/es/collections/Menu';
import './Menu.css';

export default Menu;
